var map = {
	"./1006.svg": 75152,
	"./1008.svg": 60603,
	"./1010.svg": 30253,
	"./1011.svg": 35404,
	"./1014.svg": 27364,
	"./1015.svg": 52995,
	"./1016.svg": 14192,
	"./1017.svg": 52825,
	"./1020.svg": 85984,
	"./1021.svg": 70667,
	"./1022.svg": 83345,
	"./1023.svg": 61125,
	"./1024.svg": 34853,
	"./1025.svg": 14609,
	"./1026.svg": 7917,
	"./1027.svg": 96599,
	"./1028.svg": 70843,
	"./1029.svg": 23118,
	"./1030.svg": 53383,
	"./1031.svg": 25065,
	"./1035.svg": 38305,
	"./1036.svg": 23612,
	"./1037.svg": 67827,
	"./1038.svg": 38898,
	"./1040.svg": 27956,
	"./1041.svg": 75882,
	"./1042.svg": 30159,
	"./1043.svg": 64518,
	"./1044.svg": 58011,
	"./1052.svg": 9006,
	"./1054.svg": 77546,
	"./1066.svg": 80590,
	"./1071.svg": 208,
	"./1073.svg": 51986,
	"./1078.svg": 57249,
	"./1080.svg": 73887,
	"./1081.svg": 52534,
	"./1082.svg": 36250,
	"./1083.svg": 81864,
	"./1084.svg": 69998,
	"./1088.svg": 86563,
	"./1104.svg": 23455,
	"./1105.svg": 64215,
	"./1106.svg": 17693,
	"./1107.svg": 82878,
	"./1109.svg": 37091,
	"./1110.svg": 24523,
	"./1111.svg": 54629,
	"./1112.svg": 55094,
	"./1113.svg": 52822,
	"./1114.svg": 94271,
	"./1115.svg": 76573,
	"./1116.svg": 94187,
	"./1117.svg": 65294,
	"./1118.svg": 30070,
	"./1120.svg": 73604,
	"./1122.svg": 52235,
	"./1123.svg": 75986,
	"./1124.svg": 59731,
	"./1125.svg": 31163,
	"./1127.svg": 9245,
	"./1145.svg": 67428,
	"./1148.svg": 45082,
	"./1160.svg": 90512,
	"./1161.svg": 86499,
	"./1162.svg": 77300,
	"./1171.svg": 27803,
	"./5021.svg": 99660,
	"./Carbon-Dioxide-alarm.svg": 70885,
	"./air-conditioner.svg": 53663,
	"./bath.svg": 80341,
	"./bath2.svg": 24671,
	"./elevator.svg": 62080,
	"./fire-alarm.svg": 22950,
	"./fire-extinguisher.svg": 57024,
	"./tumble-dryer.svg": 37985,
	"./washing-machine.svg": 97371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8156;